import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const Logo = ({ className, size = "md" }: LogoProps) => {
  const navigate = useNavigate();
  const sizes = {
    sm: "h-6",
    md: "h-8",
    lg: "h-12"
  };

  const textSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-3xl"
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div 
      className={cn("flex items-center gap-2 cursor-pointer", className)}
      onClick={handleLogoClick}
    >
      <img
        src="/lovable-uploads/TaleCraft.png"
        alt="TaleCraft"
        className={cn(
          sizes[size],
          "object-contain"
        )}
      />
      <span className={cn(
        "font-serif font-bold text-[#ffd700]",
        textSizes[size]
      )}>
        TaleCraft
      </span>
    </div>
  );
};
